import { render, staticRenderFns } from "./FoxForesightSettings.vue?vue&type=template&id=f63875dc"
import script from "./FoxForesightSettings.vue?vue&type=script&lang=js"
export * from "./FoxForesightSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports